import styled from "styled-components";
import { Row } from "uikit";

const Root = styled(Row)`
	padding: 16px 20px;
`;

export default Root;
